export class CrationListItemModel {
    public id: number;
    public contestTitle: string;
    public submittedBy: string;
    public designFile: string;
    public totalVotes: string;
}



// WEBPACK FOOTER //
// ./src/models/creation/creation.list.item.model.ts